import ExperimentationGroupUnifiedResourceInstance from "../../../../resources/expapiunified/ExperimentationGroup.unified.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const builder = createUnifiedRestApi(
  ExperimentationGroupUnifiedResourceInstance,
  "experimentation-groups",
  (state) => state.experimentationGroups
);
const {
  epic: experimentationGroupsEpic,
  reducer: experimentationGroupsReducer,
  actions,
  matchers: experimentationGroupsMatchers,
  selectors,
  getDefaultReducerState: getDefaultExperimentationGroupsReducerState
} = builder.create();
const {
  selectAll: selectAllExperimentationGroups,
  selectById: selectExperimentationGroupById,
  selectGetAsyncRequest: selectGetExperimentationGroupAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateExperimentationGroupAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteExperimentationGroupAsyncRequest,
  selectQueryAsyncRequest: selectQueryExperimentationGroupsAsyncRequest
} = selectors;
const {
  createOrUpdateAsync: createOrUpdateExperimentationGroupAsync,
  resetCreateOrUpdateAsync: resetCreateOrUpdateExperimentationGroupAsync,
  getAsync: getExperimentationGroupAsync,
  resetGetAsync: resetGetExperimentationGroupAsync,
  queryAsync: queryExperimentationGroupsAsync,
  deleteAsync: deleteExperimentationGroupAsync,
  resetDeleteAsync: resetDeleteExperimentationGroupAsync
} = actions;
export {
  createOrUpdateExperimentationGroupAsync,
  deleteExperimentationGroupAsync,
  experimentationGroupsEpic,
  experimentationGroupsMatchers,
  experimentationGroupsReducer,
  getDefaultExperimentationGroupsReducerState,
  getExperimentationGroupAsync,
  queryExperimentationGroupsAsync,
  resetCreateOrUpdateExperimentationGroupAsync,
  resetDeleteExperimentationGroupAsync,
  resetGetExperimentationGroupAsync,
  selectAllExperimentationGroups,
  selectCreateOrUpdateExperimentationGroupAsyncRequest,
  selectDeleteExperimentationGroupAsyncRequest,
  selectExperimentationGroupById,
  selectGetExperimentationGroupAsyncRequest,
  selectQueryExperimentationGroupsAsyncRequest
};
//# sourceMappingURL=experimentation-groups.js.map
